<div class="disable-full-screen" [style.opacity]="modal.is_active ? 100 : 0" [style.visibility]="modal.is_active ? 'visible' : 'hidden'">
  <div class="background" [@background] (click)="closeModal()"></div>
  <div class="loader absolute" *ngIf="isLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
  <div class="container-center" *ngIf="!isLoading">
    <div class="modal" [ngClass]="modalClass" [@dialog]>
      <app-dealer-plan-notification *ngIf="m_dealer_plan_notification.is_active" [modal]="m_dealer_plan_notification" (onClose)="onClosePlanNotice($event)"></app-dealer-plan-notification>
      <setting-plan-precautions *ngIf="m_plan_precaution.is_active" [modal]="m_plan_precaution" (onClose)="onClosePlanPrecaution($event)"></setting-plan-precautions>
      <setting-plan-payment *ngIf="m_plan_payment.is_active" [modal]="m_plan_payment" (onClose)="onClosePlan($event)"></setting-plan-payment>
    </div>
  </div>
</div>
<dealer-warning [modal]="m_warning"></dealer-warning>